import React, { Component } from 'react';
import styled from 'styled-components';

class LogoSvg extends Component {
    render() {
        const { className } = this.props;

        return (
            <>
                <SVG width="151" height="22" viewBox="0 0 151 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
                    <path d="M106.658 5.57336H103.861V21.7149H106.658V5.57336Z" />
                    <path d="M101.449 5.57336H82.999V7.79446H90.8254V21.7149H93.6222V7.79446H101.449V5.57336Z" />
                    <path d="M57.8137 7.78978V5.57336H42.417V21.7149H57.8137V19.4985H45.2138V14.7523H57.1359V12.5359H45.2138V7.78978H57.8137Z" />
                    <path d="M8.4995 5.57336L0 21.7149H3.15235L10.3719 8.00956L17.5868 21.7149H20.7392L12.2397 5.57336H8.4995Z" />
                    <path d="M138.755 5.57336L130.261 21.7149H133.413L140.628 8.00956L147.843 21.7149H151L142.5 5.57336H138.755Z" />
                    <path d="M31.1923 21.7149L39.6918 5.57336H36.5394L29.3198 19.2787L22.105 5.57336H18.9526L27.4521 21.7149H31.1923Z" />
                    <path d="M77.5242 5.57336V18.7737L64.9575 5.57336H62.1606V21.7149H64.9575V9.60875L76.4813 21.7149H80.321V5.57336H77.5242Z" />
                    <path d="M12.2873 16.9416C12.2873 17.9843 11.4292 18.8307 10.3721 18.8307C9.31504 18.8307 8.45703 17.9843 8.45703 16.9416C8.45703 15.8988 9.31504 15.0525 10.3721 15.0525C11.4292 15.0525 12.2873 15.8988 12.2873 16.9416Z" />
                    <path d="M107.18 1.8891C107.18 2.93185 106.322 3.7782 105.265 3.7782C104.208 3.7782 103.35 2.93185 103.35 1.8891C103.35 0.846355 104.208 0 105.265 0C106.322 0 107.18 0.846355 107.18 1.8891Z" />
                    <path d="M142.543 16.9416C142.543 17.9843 141.685 18.8307 140.628 18.8307C139.571 18.8307 138.713 17.9843 138.713 16.9416C138.713 15.8988 139.571 15.0525 140.628 15.0525C141.685 15.0525 142.543 15.8988 142.543 16.9416Z" />
                    <path d="M126.819 15.0932C126.639 16.2435 126.236 17.1553 125.606 17.8099C124.534 18.9135 122.662 19.4746 120.036 19.4746C117.798 19.4746 115.978 18.8714 114.779 17.7304C113.712 16.7157 113.148 15.3036 113.148 13.6389C113.148 11.979 113.712 10.5621 114.779 9.54745C115.978 8.40651 117.798 7.80331 120.036 7.80331C122.662 7.80331 124.534 8.36443 125.606 9.46796C126.222 10.1086 126.625 10.997 126.81 12.1146H129.403C128.919 8.21947 126.421 5.26892 120.036 5.26892C113.878 5.26892 110.579 9.01439 110.579 13.6343C110.579 18.2541 113.878 21.9996 120.036 21.9996C126.459 21.9996 128.952 19.0117 129.412 15.0838H126.819V15.0932Z" />
                </SVG>
            </>
        );
    }
}

const SVG = styled.svg`
`;


export default LogoSvg;
